import { Injectable } from '@angular/core';
import { BaseAccessService } from '@zaoblako/web/core/models/enums/access-rules/base-access.service';
import { ProjectAccessRulesKeyEnum } from './project-access-rules-key.enum';
import { ProjectAccessRulesConst } from './project-access-rules.const';

@Injectable({
  providedIn: 'root'
})
export class ProjectAccessService extends BaseAccessService<ProjectAccessRulesKeyEnum> {
  public constructor() {
    super(ProjectAccessRulesConst);
  }

  public get projectRights() {
    return {
      canReadProject: this.globalService.isAccessRule(
        ProjectAccessRulesConst[ProjectAccessRulesKeyEnum.PROJECT_PROJECT_TASK_READ]
      ),
      canWriteProject: this.globalService.isAccessRule(
        ProjectAccessRulesConst[ProjectAccessRulesKeyEnum.PROJECT_PROJECT_TASK_WRITE]
      ),

      canReadEventCalendar: this.globalService.isAccessRule(
        ProjectAccessRulesConst[ProjectAccessRulesKeyEnum.PROJECT_PROJECT_EVENT_CALENDAR_READ]
      ),
      canWriteEventCalendar: this.globalService.isAccessRule(
        ProjectAccessRulesConst[ProjectAccessRulesKeyEnum.PROJECT_PROJECT_EVENT_CALENDAR_WRITE]
      ),

      canReadTimeReport: this.globalService.isAccessRule(
        ProjectAccessRulesConst[ProjectAccessRulesKeyEnum.PROJECT_PROJECT_TIME_REPORT_READ]
      ),

      canReadTemplate: this.globalService.isAccessRule(
        ProjectAccessRulesConst[ProjectAccessRulesKeyEnum.PROJECT_PROJECT_TEMPLATE_READ]
      ),
      canWriteTemplate: this.globalService.isAccessRule(
        ProjectAccessRulesConst[ProjectAccessRulesKeyEnum.PROJECT_PROJECT_TEMPLATE_WRITE]
      )
    };
  }

  public get projectPermissions() {
    return {
      canReadAllProjects: this.globalService.isAccessRule(
        ProjectAccessRulesConst[ProjectAccessRulesKeyEnum.PROJECT_PROJECT_CAN_READ_ALL_PROJECTS]
      ),
      canDeleteOtherUserComments: this.globalService.isAccessRule(
        ProjectAccessRulesConst[ProjectAccessRulesKeyEnum.PROJECT_PROJECT_DELETE_OTHER_USER_COMMENTS]
      )
    };
  }
}
